// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.float_left[data-v-80267b3c]{\n  overflow-y: scroll;\n  height: 170px;\n  width: 100%;\n  -ms-overflow-style: none; /* 인터넷 익스플로러 */\n  scrollbar-width: none; /* 파이어폭스 */\n}\n.float_left[data-v-80267b3c]::-webkit-scrollbar {\n  display: none; /* 크롬, 사파리, 오페라, 엣지 */\n}\n", ""]);
// Exports
module.exports = exports;
